<div class="modal-body">
  <p class="centermodal__title">{{ 'documents.individualSignatureLink' | translate }}</p>
  <p class="centermodal__description">
    {{ 'documents.individualSignatureLinkDescription' | translate }}
    <span [class.d-none]="!(signer.email || signer.user?.phone)" [innerHTML]="'documents.signedOnBehalfOf' | translate: { email: signer.email || signer.user?.phone }"></span>
  </p>

  <div class="centermodal__form">
    <div class="text-center" *ngIf="!signer.link?.id">
      <button type="button" class="btn-M btn-filled" [disabled]="isLoading" (click)="createSignLink()">{{ 'documents.generateLink' | translate }}</button>
    </div>
    <div class="input-group input-group-sm" *ngIf="signer.link?.id">
      <input type="text" class="form-control" [value]="appService.signerLink(signer.link)" readonly #linkInputElement />
      <div class="input-group-append">
        <button type="button" class="btn-S btn-filled-cancel icon-only" type="button" (click)="copySignatureLink()" [ngxClipboard]="linkInputElement"><i class="far fa-copy"></i></button>
      </div>
    </div>
    <p *ngIf="signer.link?.id">
      <small class="text-danger"><i class="fal fa-exclamation-triangle"></i> {{ 'documents.doNotShareLink' | translate }}</small>
    </p>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    <button type="button" class="btn-M btn-filled-danger" [disabled]="isLoading" (click)="deleteSignLink()" *ngIf="signer.link?.id">
      {{ 'button.revokeLink' | translate }}
    </button>
  </div>
</div>
